export enum EReward {
  FreePlan = 'Free plan',
  // BalanceTopUp = 'Balance top up',
}
